// @flow
import React, {Component} from 'react';

import type {ComponentType} from 'react';
import type {EventArgs} from 'react-ga';



if (
  typeof window !== 'undefined' &&
  typeof document !== 'undefined' &&
  window.location.host === window.PRODUCTION_HOST
) {
  window.RGA = require('react-ga');
  window.RGA.initialize(window.GA_PROPERTY_ID);
  window.RGA.plugin.require('linkid', {levels: 7}); // Using 7 levels due to depth of navbar
}

if (typeof window !== 'undefined' && window.location.host !== window.PRODUCTION_HOST) {
  window.RGA = {
    initialize: (a) => {},
    set: (a) => {},
    plugin: {
        require: (a, b) => {},
    },
    pageview: (a, b) => {},
    event: (a) => {},
    modalview: (a) => {},
  };
}

type Props = {
  location: {
    pathname: string,
  }
}

const withAnalytics = (WrappedComponent: ComponentType<*>, options: {} = {}) => {
  const trackPage = page => {
    setTimeout(() => {
      set({
        page,
        ...options,
      });
      pageview(page);
    });
  };

  class HOC extends Component<Props> {
    componentDidMount() {
      const {pathname} = this.props.location;
      trackPage(pathname);
    }

    UNSAFE_componentWillReceiveProps(nextProps: Props) {
      const {pathname} = this.props.location;
      const nextPathname = nextProps.location.pathname;

      if (pathname !== nextPathname) {
        trackPage(nextPathname);
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };

  return HOC;
};

export default withAnalytics;

export function event(eventObject: EventArgs) {
  window.RGA.event(eventObject);
}

export function set(setObject: {[string]: string}) {
  window.RGA.set(setObject);
}

export function modalview(name: string) {
  window.RGA.modalview(name);
}

export function pageview(page: string, title?: string) {
  window.RGA.pageview(page, title);
}



// WEBPACK FOOTER //
// ./client/utilities/withAnalytics.js